var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';

var SvgEquaLogo32X32 = function SvgEquaLogo32X32(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.456 31C6.916 31 0 24.071 0 15.515 0 6.958 6.916.029 15.456.029S30.91 6.96 30.91 15.515C30.91 24.07 23.995 31 15.455 31zm0-28.451c-7.126 0-12.941 5.827-12.941 12.966 0 7.139 5.815 12.965 12.94 12.965 7.126 0 12.941-5.774 12.941-12.965 0-7.192-5.815-12.966-12.94-12.966z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.261 8.533c0 1.575-1.31 2.887-2.881 2.887h-7.545a2.518 2.518 0 00-2.515 2.52c0 .105-.104.21-.21.21-.104 0-.209-.105-.209-.21v-2.677c0-1.575 1.31-2.887 2.882-2.887h10.216c.157-.053.262.052.262.157z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.904 13.414h-8.068c-1.572 0-2.881 1.312-2.881 2.887v2.677c0 .105.104.21.21.21.104 0 .209-.105.209-.21 0-1.365 1.1-2.52 2.514-2.52h5.397c1.572 0 2.881-1.312 2.881-2.887a.288.288 0 00-.262-.157z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.756 18.454h-5.92c-1.572 0-2.881 1.312-2.881 2.887v2.677c0 .105.104.21.157.21.104 0 .21-.105.21-.21 0-1.364 1.1-2.52 2.514-2.52h3.248c1.572 0 2.882-1.312 2.882-2.886 0-.053-.105-.158-.21-.158z",
    fill: "#fff"
  })));
};

export default SvgEquaLogo32X32;